export enum PublicationProfileTab {
  Overview,
  Settings,
  Log,
  Delete
}
